// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"cb6bb57c","429":"91af00a8","796":"6a7cc929"}[chunkId] + ".chunk.js";
};